/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CampaignLinkDto,
    CampaignLinkDtoFromJSON,
    CampaignLinkDtoToJSON,
    CampaignLinkResolveDto,
    CampaignLinkResolveDtoFromJSON,
    CampaignLinkResolveDtoToJSON,
    CreateCampaignLinkDto,
    CreateCampaignLinkDtoFromJSON,
    CreateCampaignLinkDtoToJSON,
    UpdateCampaignLinkDto,
    UpdateCampaignLinkDtoFromJSON,
    UpdateCampaignLinkDtoToJSON,
} from '../models';

export interface CampaignLinkControllerCreateRequest {
    createCampaignLinkDto: CreateCampaignLinkDto;
}

export interface CampaignLinkControllerDeleteRequest {
    id: string;
}

export interface CampaignLinkControllerGetRequest {
    slug: string;
}

export interface CampaignLinkControllerUpdateRequest {
    id: string;
    updateCampaignLinkDto: UpdateCampaignLinkDto;
}

/**
 * 
 */
export class CampaignLinksApi extends runtime.BaseAPI {

    /**
     * Create campaign link
     */
    async campaignLinkControllerCreateRaw(requestParameters: CampaignLinkControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CampaignLinkDto>> {
        if (requestParameters.createCampaignLinkDto === null || requestParameters.createCampaignLinkDto === undefined) {
            throw new runtime.RequiredError('createCampaignLinkDto','Required parameter requestParameters.createCampaignLinkDto was null or undefined when calling campaignLinkControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/campaign-links`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCampaignLinkDtoToJSON(requestParameters.createCampaignLinkDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignLinkDtoFromJSON(jsonValue));
    }

    /**
     * Create campaign link
     */
    async campaignLinkControllerCreate(requestParameters: CampaignLinkControllerCreateRequest, initOverrides?: RequestInit): Promise<CampaignLinkDto> {
        const response = await this.campaignLinkControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete campaign link
     */
    async campaignLinkControllerDeleteRaw(requestParameters: CampaignLinkControllerDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling campaignLinkControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/campaign-links/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete campaign link
     */
    async campaignLinkControllerDelete(requestParameters: CampaignLinkControllerDeleteRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.campaignLinkControllerDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get campaign link by slug
     */
    async campaignLinkControllerGetRaw(requestParameters: CampaignLinkControllerGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CampaignLinkResolveDto>> {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug','Required parameter requestParameters.slug was null or undefined when calling campaignLinkControllerGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/campaign-links/{slug}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignLinkResolveDtoFromJSON(jsonValue));
    }

    /**
     * Get campaign link by slug
     */
    async campaignLinkControllerGet(requestParameters: CampaignLinkControllerGetRequest, initOverrides?: RequestInit): Promise<CampaignLinkResolveDto> {
        const response = await this.campaignLinkControllerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all campaign links for admin
     */
    async campaignLinkControllerGetAdminListRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CampaignLinkDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/campaign-links`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CampaignLinkDtoFromJSON));
    }

    /**
     * Get all campaign links for admin
     */
    async campaignLinkControllerGetAdminList(initOverrides?: RequestInit): Promise<Array<CampaignLinkDto>> {
        const response = await this.campaignLinkControllerGetAdminListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update campaign link
     */
    async campaignLinkControllerUpdateRaw(requestParameters: CampaignLinkControllerUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CampaignLinkDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling campaignLinkControllerUpdate.');
        }

        if (requestParameters.updateCampaignLinkDto === null || requestParameters.updateCampaignLinkDto === undefined) {
            throw new runtime.RequiredError('updateCampaignLinkDto','Required parameter requestParameters.updateCampaignLinkDto was null or undefined when calling campaignLinkControllerUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/campaign-links/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCampaignLinkDtoToJSON(requestParameters.updateCampaignLinkDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignLinkDtoFromJSON(jsonValue));
    }

    /**
     * Update campaign link
     */
    async campaignLinkControllerUpdate(requestParameters: CampaignLinkControllerUpdateRequest, initOverrides?: RequestInit): Promise<CampaignLinkDto> {
        const response = await this.campaignLinkControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
